import { render, staticRenderFns } from "./FolderMediaForm.vue?vue&type=template&id=26a0cc04&"
import script from "./FolderMediaForm.vue?vue&type=script&lang=js&"
export * from "./FolderMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports